// Pure comparators for matching a review-draft / ticket context (connection +
// conversation [+ message]). No shared state — these are framework-agnostic helpers
// shared by the Vue app (useReviewDraft, ContentLists) and state selectors
// (conversation-list). connectionId is string-coerced because it arrives as a
// number from route params but a string from draft/api payloads.
export interface ComparableDraftContext {
  connectionId?: number | string | null
  conversationId?: string
  messageId?: string | null
}

export const draftContextMatches = (draft: ComparableDraftContext, context: ComparableDraftContext) =>
  String(draft.connectionId ?? '') === String(context.connectionId ?? '') &&
  draft.conversationId === context.conversationId &&
  (draft.messageId || '') === (context.messageId || '')

export const draftConversationMatches = (draft: ComparableDraftContext, context: ComparableDraftContext) =>
  String(draft.connectionId ?? '') === String(context.connectionId ?? '') &&
  draft.conversationId === context.conversationId
